import type { AccessPermission } from "@entrilia/shared/api/types.ts";
import type { ClientInfo } from "../../../../../../api/types/clientTypes.ts";
import type { ClientInfoExtended } from "../../../../../../api/types/svTypes.ts";
import { FundType } from "../../../../../../api/types/svTypes.ts";

export function getAccessibleCompanies(
  clients: ClientInfo[],
  permissions: { clientCode: string; permissions: AccessPermission[] }[],
  clientCode: string
) {
  return clients.filter((c) => {
    const companyPermissions = permissions.find((p) => p.clientCode === c.clientCode);
    return (
      c.type === "FundManager" &&
      c.managedByClients.includes(clientCode) &&
      companyPermissions?.permissions.includes("ManageReports")
    );
  }) as ClientInfoExtended[];
}

export const formatFundType = (fundType: FundType): string => {
  switch (fundType) {
    case FundType.FundOfFunds:
      return "Fund of Funds";
    case FundType.PrivateEquity:
      return "Private Equity";
    case FundType.VentureCapital:
      return "Venture Capital";
    default:
      return "";
  }
};
